import React, { useState } from 'react';
import { createTheme, WuiProvider } from '@welcome-ui/core';
import { ThemeProvider, createTheme as muiTheme } from '@mui/material/styles';
import { darkTheme } from '@welcome-ui/themes.dark';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useQuery } from 'react-query';

import { NotificationProvider } from './context/notification';
import { DataProvider } from './context/globalData';
import { useAuth } from './context/auth';
import { getUserRights } from './api/admin';
import ErrorBoundary from './context/ErrorBoundary';

import Header from './layouts/Header';
import RequireAuth from './pages/admin/RequireAuth';
import Login from './pages/admin/Login';
import Ticker from './pages/carousels/Ticker';
import Notification from './components/Notification';
import NotFound from './components/NotFound';
import Database from './pages/admin/Database';
import Footer from './layouts/Footer';
import Users from './pages/admin/Users';
import Signup from './pages/admin/Signup';
import Theme from './pages/admin/Theme';

import './style/css/style.css';
import './style/css/main.css';
import './style/css/output.css';

const theme = createTheme(darkTheme);
const dark = muiTheme({
  palette: {
    mode: 'light',
  },
});
function App() {
  const auth = useAuth();

  const [interval, setInterval] = useState(3000);

  useQuery('user', getUserRights, {
    onSuccess: (res) => {
      auth.login(res);
      setInterval(3000);
    },
    onError: () => {
      setInterval(null);
    },
    retry: false,
    refetchInterval: interval,
  });

  return (
    <Router>
      <ThemeProvider theme={dark}>
        <WuiProvider theme={theme}>
          <NotificationProvider>
            <DataProvider>
              <ErrorBoundary>
                <div className="App relative">
                  <Header />
                  <Notification />
                  <Routes>
                    {!auth.user ? (
                      <Route path="/login" element={<Login />} />
                    ) : (
                      <Route path="/login" element={<Navigate to="/" />} />
                    )}
                    <Route
                      path="/"
                      element={
                        <RequireAuth>
                          <Ticker />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/admin/database"
                      element={
                        <RequireAuth admin>
                          <Database />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/admin/users"
                      element={
                        <RequireAuth admin>
                          <Users />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/admin/signup"
                      element={
                        <RequireAuth admin>
                          <Signup />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/admin/theme"
                      element={
                        <RequireAuth theme>
                          <Theme />
                        </RequireAuth>
                      }
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  <Footer />
                </div>
              </ErrorBoundary>
            </DataProvider>
          </NotificationProvider>
        </WuiProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;

// remettre <Tabs /> sous <HeaderApp/> pour la V1 fonctionnelle
